import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionResultsOptionsItem = observer(({option}) => {
  const containerProps = {
    className: classNames(styles.results_options_item, {[styles.results_options_active_item] : option.isSelected}),
    style: {
      animationDelay: `${option.delayMS}ms`,
      animationDuration: `${option.animationDuration}ms`
    }
  }

  return (
    <div {...containerProps}>
      <div className={classNames(styles.results_options_vote)}>{option.vote.percentage}</div>
      <div className={classNames(styles.results_options_name)}>{option.name}</div>
    </div>
  )
});
